import { render, staticRenderFns } from "./SelectMenu.vue?vue&type=template&id=997572da&scoped=true&"
import script from "./SelectMenu.vue?vue&type=script&lang=ts&"
export * from "./SelectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SelectMenu.vue?vue&type=style&index=0&id=997572da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997572da",
  null
  
)

export default component.exports